/**
 * Error state component shown when favorites fail to load.
 */
export const FavoritesErrorState = () => {
  return (
    <div className="text-center py-20 bg-surface rounded-3xl shadow-sm">
      <div className="mx-auto h-24 w-24 text-error">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h3 className="mt-2 text-sm  text-main">Error loading favorites</h3>
      <p className="mt-1 text-sm text-muted">Please try refreshing the page.</p>
    </div>
  );
};
